import { useState, useRef, useEffect } from "react";
import { useSmartIdSessionPolling } from "components/account/SmartId/Shared/useSmartIdSessionPolling";
import { SMART_ID_POLLING_RESULT } from "components/account/SmartId/Shared/smartIdConstants";
import FetcherApi from "components/components/FetcherApi.jsx";
import { pushAccountEvent } from "components/tools/GaEvents/GaEventSender.jsx";
import { GaEventActionConstants } from "components/tools/GaEvents/GaEventActionConstants.jsx";
import webTools from "components/tools/webTools.js";
import SmartIdErrorMessagesService from "components/services/SmartIdErrorMessagesService.js";

export function useSmartIdLoginLogic(wizard, legalEntityId) {
  const [personalCodeEntryError, setPersonalCodeEntryError] = useState("");
  const isMountedRef = useRef(true);
  
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  
  const {
    pin,
    sessionPollingError,
    isAuthenticating,
    startPersonalCodeSession,
    pollPersonalCodeSession,  
    setSessionPollingError,
    resetError    
  } = useSmartIdSessionPolling();

  const loginWithSmartId = async () => {
    const result = (await FetcherApi.post("/api/account/login-smart-id")).response.data;
    if (!result.success) {     
      pushAccountEvent(GaEventActionConstants.UserLoginFail);
      
      processLoginResultError(result.error);
    } else {
      pushAccountEvent(GaEventActionConstants.UserLoginSuccess);
      webTools.reloadToRoute();
    }
  };

  const handlePersonalCodeSubmit = async (validPersonalCode) => {
    await startSmartIdVerification(validPersonalCode);
  };

  const startSmartIdVerification = async (validPersonalCode) => {
    const result = await startPersonalCodeSession(validPersonalCode, legalEntityId);
    
    if (!result.success) {
      processPersonalCodeResultError(result.error);
    } else {
      wizard.nextStep();
      await startPollingSessionStep();
    }
  };

  const startPollingSessionStep = async () => {
    if (!isMountedRef.current) {
      return;
    }
    
    const result = await pollPersonalCodeSession();
    console.debug("startPollingSessionStep intermediate result:", result);

    if (!isMountedRef.current) {
      return;
    }
    
    if (result === SMART_ID_POLLING_RESULT.SUCCESS) {
      await loginWithSmartId();      
    } else if (result === SMART_ID_POLLING_RESULT.CONTINUE) {
      await startPollingSessionStep(); // Continue polling
    }
  };

  const processPersonalCodeResultError = (error) => {
    setPersonalCodeEntryError(error);
  };

  const processLoginResultError = (error) => {    
    if (error === "invalidConsents" || error === "oldConsents") {
      webTools.reloadToRoute("ConsentsAcceptance");
    } else {
      const message = SmartIdErrorMessagesService.getErrorMessage(error);
      setSessionPollingError(message);
    }    
  }

  return {
    pin,
    sessionPollingError,
    isAuthenticating,
    personalCodeEntryError,
    setPersonalCodeEntryError,    
    handlePersonalCodeSubmit,
    resetError 
  };
}
